export const getEmployeeId = (selectedPartner, currentUser) => {
  if (selectedPartner) {
    return (selectedPartner.EmployeeId && currentUser.IsAdmin && window.location.href.indexOf('admin/admincentre') > 0)
      ? selectedPartner.EmployeeId : currentUser.EmployeeId
  }
  if (currentUser) {
    return (currentUser.EmployeeId)
  }
  return ('')
}




// WEBPACK FOOTER //
// ./src/utils/getEmployeeId.js